import instance from '@apis/instance';
import { DiscountPrepaidCardResponse, DiscountResponse } from '@models/discount';

class DiscountApi {
    static getDiscounts(shopId: string): Promise<DiscountResponse> {
        return instance.get('/v1/discounts', { params: { shopId } });
    }

    static getDiscountPrepaidCards(shopId: string): Promise<DiscountPrepaidCardResponse> {
        return instance.get('/v0/discounts/prepaid-cards', { params: { shopId } });
    }
}

export default DiscountApi;
